/**
 * ParagraphText React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2020 contexagon GmbH
 */


import React from 'react';
import PropTypes from 'prop-types';


// define pattern for splitting at two line breaks (at least),
// ignoring other whitespace
// (using non-capturing grouping because captured groups
// would be part of the resulting array for some strange reason)
const splitPattern = /\s*(?:\n\s*){2,}/;


/**
 * component for text with multiple paragraphs given by double line breaks
 *
 * @author Jens Gruschel
 */
function ParagraphText(props) {

    if (!props.text) return null;
    const paragraphs = props.text.trim().split(splitPattern);
    return <>{paragraphs.map((paragraph, index) => <p key={index}>{paragraph}</p>)}</>;
}


ParagraphText.propTypes = {
    text: PropTypes.string
};


export default ParagraphText;
